import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';

/**
 * Replaces angular2-materialize sideNav. Toggle target panel by data-activates="id".
 * Adds backdrop and shows/hides the side panel on trigger click.
 */
@Directive({
  selector: '[materialize="sideNav"]',
})
export class SideNavDirective implements OnInit, OnDestroy {
  @Input() materializeParams: { menuWidth?: number }[] = [];

  private panel: HTMLElement | null = null;
  private backdrop: HTMLElement | null = null;
  private menuWidth = 250;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    const params = this.materializeParams?.[0];
    if (params?.menuWidth) this.menuWidth = params.menuWidth;

    const trigger = this.el.nativeElement;
    const targetId = trigger.getAttribute('data-activates');
    if (targetId) {
      this.panel = document.getElementById(targetId);
      if (this.panel) {
        this.renderer.setStyle(this.panel, 'transform', 'translateX(-100%)');
        this.renderer.setStyle(this.panel, 'transition', 'transform 0.3s ease');
        this.renderer.setStyle(this.panel, 'z-index', '999');
        this.renderer.setStyle(this.panel, 'position', 'fixed');
        this.renderer.setStyle(this.panel, 'top', '0');
        this.renderer.setStyle(this.panel, 'left', '0');
        this.renderer.setStyle(this.panel, 'width', `${this.menuWidth}px`);
        this.renderer.setStyle(this.panel, 'height', '100%');
      }
    }
    this.renderer.listen(trigger, 'click', (e: Event) => {
      e.preventDefault();
      this.toggle();
    });
  }

  private toggle() {
    if (!this.panel) return;
    const isOpen = this.panel.classList.contains('sr-sidenav-open');
    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  private open() {
    if (!this.panel) return;

    this.panel.classList.add('sr-sidenav-open');
    this.panel.style.transform = 'translateX(0)';

    this.addBackdrop();
  }

  private close() {
    if (!this.panel) return;

    this.panel.classList.remove('sr-sidenav-open');
    this.panel.style.transform = 'translateX(-100%)';
    this.removeBackdrop();
  }

  private addBackdrop() {
    if (this.backdrop) return;

    this.backdrop = this.renderer.createElement('div');
    this.renderer.addClass(this.backdrop, 'sr-sidenav-backdrop');
    this.renderer.setStyle(this.backdrop, 'position', 'fixed');
    this.renderer.setStyle(this.backdrop, 'top', '0');
    this.renderer.setStyle(this.backdrop, 'left', '0');
    this.renderer.setStyle(this.backdrop, 'right', '0');
    this.renderer.setStyle(this.backdrop, 'bottom', '0');
    this.renderer.setStyle(this.backdrop, 'background', 'rgba(0,0,0,0.5)');
    this.renderer.setStyle(this.backdrop, 'z-index', '998');
    this.renderer.setStyle(this.backdrop, 'opacity', '0');
    this.renderer.setStyle(this.backdrop, 'transition', 'opacity 0.3s ease');

    this.renderer.appendChild(document.body, this.backdrop);
    this.renderer.listen(this.backdrop, 'click', () => this.close());
  }

  private removeBackdrop() {
    if (!this.backdrop) return;

    if (this.backdrop && this.backdrop.parentNode) {
      this.renderer.removeChild(document.body, this.backdrop);
      this.backdrop = null;
    }
  }

  ngOnDestroy() {
    this.removeBackdrop();
  }

}
